import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NewbieMessageDonor from './NewbieMessageDonor';
import NewbieMessageDonee from './NewbieMessageDonee';
import MyRecord from './MyRecord';
import { useApi } from '../../hooks/useApi';
import { useAuthUserContext } from '../../providers';
import { UserType } from '../../types';
import { useTitle } from '../../hooks/useTitle';

const MypageTop = () => {

  const [ unreadMsgCount, setUnreadMsgCount ] = useState<number>(0);
  const [ pendingRecordCount, setPendingRecordCount ] = useState<number>(0);
  const [ hasDraftCheckup, setHasDraftCheckup ] = useState<boolean>(false);
  const { get } = useApi();
  const authUser = useAuthUserContext().user;
  const isDonee = authUser?.userType === UserType.Donee;

  useTitle('Ton Bébé | マイページ');

  useEffect(() => {
    get({
      endpoint: '/api/v1/unread_msg_count',
      onSuccess: (res) => {
        setUnreadMsgCount(res.data.unread_count);
      },
      onError: (err) => {
        console.error("[GET FAILED] /unread_msg_count")
      },
    });
  }, [get])

  useEffect(() => {
    if (isDonee) {
      get({
        endpoint: '/api/v1/donor_records/pending_count',
        onSuccess: (res) => {
          setPendingRecordCount(res.data.pending_count);
        },
        onError: (err) => {
          console.error("[GET FAILED] /donor_records/pending_count")
        },
      });
    }
  }, [ get, isDonee ])

  return (
    <main className="sub">
      <section className={ isDonee ? "donee_top pink" : "donor_top" }>
        { unreadMsgCount > 0 &&
          <Link to="/mypage/messages" className="sub_title unread_message">
            新着メッセージがあります。<br className="smonly" />メッセージをご確認ください。
          </Link>
        }
        { isDonee && pendingRecordCount > 0 &&
          <Link to="/mypage/records" className="sub_title unread_message">
            未承認の提供申請が{ pendingRecordCount }件あります。<br className="smonly" />提供実績をご確認ください。
          </Link>
        }
        { !isDonee && hasDraftCheckup &&
          <Link to="/mypage/checkups#register_form" className="sub_title unread_message">
            未提出の検査結果があります。<br className="smonly" />「登録・入金手続き」を行なってください。
          </Link>
        }
        { isDonee ? <NewbieMessageDonee /> : <NewbieMessageDonor setHasDraftCheckup={ setHasDraftCheckup } /> }
        <MyRecord />
      </section>
    </main>
  );
}

export default MypageTop;
